<div>
    <button *ngIf="hasPermissions('manage_providers')" style="margin: 15px" class="floatR marginB" nz-button nzType="primary" nzShape="circle" (click)="showModal(false)">
        <span nz-icon nzType="plus" nzTheme="outline"></span>
    </button>

    <div style="padding: 20px">
        <nz-input-group nzPrefixIcon="search">
          <input style="padding: 10px" (keyup)="search($event)" type="text" nz-input placeholder="Search by Provider or Contact Info" />
        </nz-input-group>
      </div>

    <div>
        <nz-table #providersTable [nzLoading]="loading" [nzData]="providersList">
          <thead>
            <tr>
              <th>Provider</th>
              <th>Contact Name</th>
              <th>Contact number</th>
              <th>Contact Emails</th>
              <th *ngIf="hasPermissions('manage_providers')"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of providersTable.data" nzShowSizeChanger>
              <td>{{p.name}}</td>
              <td>{{p.primary_contact_name}}</td>
              <td>{{p.primary_contact_phone}}</td>
              <td>{{ p.contact_emails?.join ? p.contact_emails.join(', ') : '—' }}</td>
              <td *ngIf="hasPermissions('manage_providers')">
                <button (click)="showModal(p)" nz-button nzType="primary" nzShape="circle">
                  <span nz-icon nzType="edit" nzTheme="outline"></span>
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
</div>

<nz-modal [(nzVisible)]="isModalVisible" nzTitle="Provider" nzCentered (nzOnCancel)="cancelAddEdit()" (nzOnOk)="confirmAddEdit()">
    <ng-container *nzModalContent>
      <form [formGroup]="providerForm">
        <nz-form-item>
          <nz-form-label nzRequired>Name</nz-form-label>
            <input nz-input formControlName="name"/>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label>Contact Name</nz-form-label>
            <input nz-input formControlName="primary_name"/>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label>Contact Phone</nz-form-label>
            <input nz-input mask="(000) 000-0000" formControlName="primary_phone"/>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label>Contact Email</nz-form-label>
              <input nz-input formControlName="primary_email"/>
        </nz-form-item>

        <nz-form-control>
          <nz-form-label nzFor="contactEmailsField" nzTooltipTitle="These contacts receive provider request emails." nzTooltipIcon="info-circle">
            Provider Request Contacts (Press enter to add email, then save)
          </nz-form-label>
          <input nz-input id="contactEmailsField" formControlName="contact_emails" (keyup.enter)="addContactEmail()" placeholder="Add an email" />
          <nz-tag *ngFor="let chip of contactEmails" nzMode="closeable" (nzOnClose)="removeContactEmail(chip)">
            {{ chip }}
          </nz-tag>
        </nz-form-control>

        <nz-form-control>
          <nz-form-label nzFor="dropdownField" nzTooltipTitle="These are the email addresses that will receive notifications when a user requiring a background check is onboarded." nzTooltipIcon="info-circle">
            Background Check Contacts (Press enter to add email, then save)
          </nz-form-label>
          <input nz-input formControlName="bg_emails" (keyup.enter)="addBgEmail()" placeholder="Add a email" />
          <nz-tag *ngFor="let chip of bgEmails" nzMode="closeable" (nzOnClose)="removeBgEmail(chip)">
            {{ chip }}
          </nz-tag>
        </nz-form-control>

        <nz-form-control>
          <nz-form-label>Promo</nz-form-label>
          <input nz-input formControlName="promo"/>
          <nz-form-label>Promo Link</nz-form-label>
          <input nz-input formControlName="promo_link"/>
        </nz-form-control>
          
      </form>
    </ng-container>
</nz-modal>
